import { IChannel } from "@Interfaces";

/**
 * True when the user id matches any of the channel admins (string ids or populated admins).
 * @param channel - Channel whose admins to check
 * @param userId - Logged-in user id; empty for guests
 */
export const isUserChannelAdmin = (
    channel: IChannel | null | undefined,
    userId: string | null | undefined
): boolean => {
    if (!userId || !Array.isArray(channel?.admins)) {
        return false;
    }

    return channel!.admins.some((admin) =>
        typeof admin === "string"
            ? admin === userId
            : admin?._id === userId || admin?.id === userId
    );
};
